
import React from 'react'
import {InfoContainer, InfoWrapper, InfoRow, Column1,TopLine, TextWrapper,
   Boldtitle, Heading, Subtitle, Column2, Img, Column3 } from './ProblemElements'

import { useTranslation } from 'react-i18next';



function ProblemSection({lightBg, imgStart, lightText,
  description, darkText, Icon1, id, alt, description2, Icon2,  description3, Icon3}) {
  const {t} = useTranslation();
  return (
		<>
		<InfoContainer lightBg={lightBg} id={id}>
			<InfoWrapper>
        <InfoRow imgStart={imgStart}>
          <Column1>
            <Heading>{t("problem.head")}</Heading>
            <TextWrapper>
              <Img lightText={lightText}  src={Icon1} alt={alt} />
              <Subtitle darkText={darkText} >{description}</Subtitle>		
              <Boldtitle>{t("console.problem.bolddes")}</Boldtitle>	
              <TopLine>{t("console.problem.topLine")}</TopLine>			
            </TextWrapper>
          </Column1>
          <Column2>
            <TextWrapper>
              <Img lightText={lightText}  src={Icon2} alt={alt} />
              <Subtitle darkText={darkText} >{description2}</Subtitle>		
              <Boldtitle style={{marginBottom: "5px"}}>{t("console.problem.bolddes2")}</Boldtitle>	
              <TopLine>{t("console.problem.topLine2")}</TopLine>			
            </TextWrapper>
          </Column2>
          <Column3>
            <TextWrapper>
              <Img lightText={lightText}  src={Icon3} alt={alt} />
              <Subtitle darkText={darkText} >{description3}</Subtitle>		
              <Boldtitle>{t("console.problem.bolddes3")}</Boldtitle>	
              <TopLine>{t("console.problem.topLine3")}</TopLine>			
            </TextWrapper>
          </Column3>
        </InfoRow>
			</InfoWrapper>
		</InfoContainer>	
		</>
	)
}

export default ProblemSection
